import { render, staticRenderFns } from "./TSProductGrid.vue?vue&type=template&id=c5fec408&scoped=true&"
import script from "./TSProductGrid.vue?vue&type=script&lang=ts&"
export * from "./TSProductGrid.vue?vue&type=script&lang=ts&"
import style0 from "./TSProductGrid.vue?vue&type=style&index=0&id=c5fec408&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fec408",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RowPhotoFilter: require('/app/components/filter/RowPhotoFilter/RowPhotoFilter.vue').default,RowSliderNew: require('/app/components/sliders/RowSliderNew/RowSliderNew.vue').default,FilterRow: require('/app/components/filter/FilterRow/FilterRow.vue').default,FilterRowWrapper: require('/app/components/filter/FilterRow/FilterRowWrapper.vue').default,Sort: require('/app/components/Sort/Sort.vue').default,SortSelect: require('/app/components/SortSelect/SortSelect.vue').default,SelectFilter: require('/app/components/filter/SelectFilter/SelectFilter.vue').default,TagHorizontalFilter: require('/app/components/filter/TagHorizontalFilter/TagHorizontalFilter.vue').default,TSProductCard: require('/app/components/ts-components/TSProductCard/TSProductCard.vue').default,TSProductCardGrid: require('/app/components/ts-components/TSProductCardGrid/TSProductCardGrid.vue').default,TSHybridPagination: require('/app/components/ts-components/TSHybridPagination/TSHybridPagination.vue').default})
